import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const ContactBreadcrumb = () => {
   return (
      <>
         <Breadcrumb title="Free" subTitle="Contact" smText='Adresse'></Breadcrumb>
      </>
   );
};

export default ContactBreadcrumb;